import FixedNavbar from 'components/FixedNavbar'
import Link from 'components/Link'
import { MobileScreenWidths, useScreenWidth } from 'data/hooks/useScreenWidth'
import { useEffect, useState } from 'react'

type PropTypes = {
  OptionComponent:() => JSX.Element
  showBookButton?: boolean
}

const Searchbar = ({
  OptionComponent,
  showBookButton = true,
}: PropTypes) => {
  const { isMobile } = useScreenWidth(MobileScreenWidths.LG)
  const [visible, setVisible] = useState(false)

  const handleScroll = () => {
    setVisible(window.scrollY > 0)
  }

  useEffect(() => {
    if (typeof window === 'undefined') {return}
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      {
        visible
          && <>
            {!isMobile
              ? (
                <FixedNavbar columnOneChildren={showBookButton
                  ? (
                    <Link
                      className="bg-grey-100 px-[22px] py-[8px] text-12 leading-14 border-none hover:bg-primary hover:text-white transition-full text-grey-800 uppercase rounded-full w-full max-w-[200px] text-center font-normal tracking-[0.6px] whitespace-nowrap"
                      href="/"
                    >
                      Book Your Next Stay
                    </Link>
                  )
                  : undefined
                }>
                  <OptionComponent />
                </FixedNavbar>
              )
              : null
            }
          </>
      }
    </>
  )
}

export default Searchbar
